<template>
  <div class="phone-list-container">

    <!-- 操作按钮区 -->

    <div style="margin: 10px">
      <el-input
          v-model="pageQuery.phoneNumber"
          placeholder="手机号"
          style="width: 180px"
          class="mr10"
      ></el-input>
      <el-input
          v-model="pageQuery.mainPhone"
          placeholder="主卡手机号"
          style="width: 180px"
          class="mr10"
      ></el-input>
      <el-select v-model="pageQuery.mainSend" placeholder="请选择主副卡">
        <el-option key="0" label="全部" value="0"></el-option>
        <el-option key="1" label="主卡" value="1"></el-option>
        <el-option key="2" label="副卡" value="2"></el-option>
      </el-select>
      <el-select v-model="pageQuery.phoneState" placeholder="请选择是否闲置">
        <el-option key="0" label="全部" value="0"></el-option>
        <el-option key="1" label="闲置" value="1"></el-option>
        <el-option key="2" label="使用中" value="2"></el-option>
        <el-option key="3" label="注销" value="3"></el-option>
      </el-select>
      <el-select v-model="pageQuery.useCoachId" placeholder="请选择教练-留空则是归还"
                 clearable
                 filterable="true" remote="true"
                 :remote-method="fetchCoachList"
      >
        <el-option
            v-for="tCoach in coachList"
            :key="tCoach.coachid"
            :label="tCoach.coachname"
            :value="tCoach.coachid"
        />
      </el-select>
      <el-button type="primary" @click="fetchPhoneList">搜索</el-button>
      <el-button type="primary" @click="handleAddPhone">新增工作号</el-button>
      <el-button type="success" @click="handleImportMaintain">导入维护表</el-button>
      <el-popconfirm
          title="确定导出工作号维护表吗？"
          @confirm="handleExportMaintain"
      >
        <template #reference>
          <el-button class="background-animation">导出维护表</el-button>
        </template>
      </el-popconfirm>
    </div>
    <!--统计展示项-->
    <el-row :gutter="20" style="margin: 0 auto;">
      <el-col :span="2" v-for="(item, index) in showCountData" :key="index">
        <div style="border: 1px solid;border-radius: 10px;padding: 10px;margin: 10px"
        >
          <el-statistic
              :precision="0"
              :value="item.value"
              :title="item.title"
          ></el-statistic>
        </div>
      </el-col>

    </el-row>


    <!-- 表格列表 -->
    <el-table :data="phoneList" border stripe>
      <el-table-column label="手机号" prop="phoneNumber" align="center">
      </el-table-column>

      <el-table-column label="卡类型" prop="mainPhone" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.mainPhone ? 'success' :  'danger'">
            {{ scope.row.mainPhone ? '副卡' : '主卡' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="关联主卡" prop="mainPhone" align="center">
      </el-table-column>

      <el-table-column label="宽带位置" prop="bindNet" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.bindNet ? 'danger' :  'info'">
            {{ scope.row.bindNet ? scope.row.bindNet : '仅号码' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="运营商" prop="phoneOperator" align="center"/>
      <el-table-column label="套餐费" prop="planFee" align="center"/>
      <el-table-column label="功能费" prop="useFee" align="center"/>
      <el-table-column label="实名人" prop="realName" align="center"/>
      <el-table-column label="备注" prop="remarkNote" align="center"/>
      <el-table-column label="当前使用人" align="center">
        <template #default="scope">{{ scope.row.coachName || '未分配' }}</template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.status === '使用中' ? 'success' : scope.row.status === '闲置' ? 'info' : 'danger'">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="340">
        <template #default="scope">
          <el-button size="small" @click="handleEditPhone(scope.row)">修改</el-button>
          <el-button size="small" type="warning" @click="handleTransfer(scope.row)" v-if="scope.row.status !== '停用'">
            分配/归还
          </el-button>
          <el-button size="small" type="text" @click="handleViewHistory(scope.row)">操作记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--    分页-->
    <div style="display: flex;justify-content: end;margin-top: 20px">
      <el-pagination
          v-model:current-page="pageQuery.pageIndex"
          v-model:page-size="pageQuery.pageSize"
          :page-sizes="[20, 50, 100, 150, 200, 250, 300]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          @size-change="fetchPhoneList"
          @current-change="fetchPhoneList"
      />
    </div>
  </div>

  <!-- 新增/修改弹窗 -->
  <el-dialog title="号卡新增/修改" v-model="dialogVisible" width="500px">
    <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px">
      <el-form-item label="手机号" prop="phoneNumber">
        <el-input v-model="form.phoneNumber" placeholder="请输入手机号" :disabled="isEdit"/>
      </el-form-item>
      <el-form-item label="关联主卡" prop="mainPhone">
        <el-input v-model="form.mainPhone" placeholder="请输入关联主卡手机号" :disabled="isEdit"/>
      </el-form-item>
      <el-form-item label="宽带位置" prop="bindNet">
        <el-input v-model="form.bindNet" placeholder="请输入宽带位置" :disabled="isEdit"/>
      </el-form-item>
      <el-form-item label="运营商" prop="phoneOperator">
        <el-select v-model="form.phoneOperator" placeholder="请选择运营商">
          <el-option label="中国移动" value="中国移动"/>
          <el-option label="中国联通" value="中国联通"/>
          <el-option label="中国电信" value="中国电信"/>
        </el-select>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择号卡状态">
          <el-option label="使用中" value="使用中"/>
          <el-option label="闲置" value="闲置"/>
          <el-option label="注销" value="注销"/>
        </el-select>
      </el-form-item>
      <el-form-item label="套餐费" prop="planFee">
        <el-input v-model="form.planFee" placeholder="请输入套餐费" type="number" step="0.01"/>
      </el-form-item>
      <el-form-item label="副卡功能费" prop="planFee">
        <el-input v-model="form.useFee" placeholder="请输入副卡功能费" type="number" step="0.01"/>
      </el-form-item>
      <el-form-item label="实名人" prop="realName">
        <el-input v-model="form.realName" placeholder="请输入实名人"/>
      </el-form-item>
      <el-form-item label="修改备注" prop="remarkNote" v-if="isEdit">
        <el-input v-model="form.remarkNote" placeholder="请填写修改原因/备注"/>
      </el-form-item>
    </el-form>
    <div>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>

  <!--  分配 弹框-->
  <el-dialog title="号卡分配" v-model="dialogAssignVisible" width="900px">
    <work-phone-assign @parentReload="fetchPhoneList" :phone-id="rowPhoneId" :obj="form"></work-phone-assign>
  </el-dialog>

  <!--  操作记录 弹框-->
  <el-dialog title="号卡操作记录" v-model="dialogCostVisible" width="900px">
    <el-table :data="assignmentHistory" border stripe>
      <el-table-column label="序号" type="index" width="60"/>
      <el-table-column label="所选时间" prop="assignDate" align="center"/>
      <el-table-column label="操作" prop="assignType" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.assignType===1 ? 'success' :  'danger'">
            {{
              scope.row.assignType === 1 ? '分配' : scope.row.assignType === 2 ? '归还' : scope.row.assignType === 3 ? '修改实名' : ''
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="目标教练" prop="coachName" align="center"/>
      <el-table-column label="备注" prop="remarkNote" align="center"/>
    </el-table>
  </el-dialog>


  <!-- 导入 弹框 -->
  <el-dialog title="导入号卡"
             v-model="importExcelDialog"
             width="500px"
             :append-to-body="true"
             :draggable="true"
  >
    <div style="display: flex; justify-content: center">
      <el-upload
          drag
          :limit="limitNum"
          :auto-upload="false"
          :on-change="fileChange"
          :on-exceed="exceedFile"
          :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <div style="margin:30px 0 0 20px">
      <a href="https://minio.yanhuotiyu.com/yhoss/web/%E5%AF%BC%E5%85%A5%E5%B7%A5%E4%BD%9C%E5%8F%B7.xlsx">下载导入模板！</a>
    </div>
    <div style="display: flex; justify-content: center; padding-top: 30px">
      <el-button
          type="primary"
          :loading="hintMessage!=='开始导入'"
          @click="handleImportPhone"
      >{{ hintMessage }}
      </el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  getPhonePageList,
  addPhone,
  editPhone,
  importPhone,
  exportExcel,
  loadAssignRecord,
  getPhoneCount, getListCoachAll
} from '@/api/workphone'
import WorkPhoneAssign from "@/views/workPhone/WorkPhoneAssign";
// import WorkPhoneCost from "@/views/workPhone/WorkPhoneCost";

export default {
  name: "WorkPhoneManage",
  components: {WorkPhoneAssign}, //, WorkPhoneCost
  data() {
    return {
      // pList2: ['export'],//导出权限
      phoneList: [],//数据
      dialogVisible: false,//新增,修改弹框
      dialogAssignVisible: false,//分配 弹框
      dialogCostVisible: false,//费用
      rowPhoneId: -1,//要分配的phoneId
      isEdit: false,//是否是修改
      form: {
        id: null,
        phoneNumber: '',
        phoneOperator: '',
        planFee: 0.00,
        useFee: 0.00,
        realName: '',
        remarkNote: '',
        mainPhone: '',
        bindNet: '',
        status:'',
      },//新增,修改入参
      formRules: {
        phoneNumber: [{required: true, message: '请输入手机号', trigger: 'blur'}],
        phoneOperator: [{required: true, message: '请选择运营商', trigger: 'change'}],
        realName: [{required: true, message: '请输入实名人', trigger: 'blur'}]
      },//表单验证规则
      pageQuery: {
        phoneNumber: null,//该手机号
        mainPhone: null,//主卡号码
        useCoachId:null,//当前使用者
        phoneState:null,//闲置 还是 使用中
        mainSend:null,//是主卡 还是副卡

        pageIndex: 1,
        pageSize: 100,
      },//查询入参
      pageTotal: 0,//分页数据总条数
      limitNum: 1, // 上传excel时，同时允许上传的最大数
      fileList: [],//文件list
      hintMessage: "开始导入",//按钮文字
      importExcelDialog: false,//导入弹框
      assignmentHistory: [], // 某号码的分配和归还历史
      showCountData: [],//号码 统计数据
      coachList:[],//搜索教练集合

    }
  },
  mounted() {
    //加载号卡
    this.fetchPhoneList()

    //加载可分配的教练
    this.fetchCoachList("");
  },
  methods: {
    // 获取教练列表
    fetchCoachList(inputCoachName) {
      getListCoachAll({
        keyword: inputCoachName || "", // 关键字参数
      }).then(res => {
        if (res.code === 200) {
          this.coachList = res.data
        } else {
          this.$message.error(`请求校区负责人失败！`);
        }
      })
    },
    // 获取工作号列表
    fetchPhoneList() {
      getPhonePageList(this.pageQuery).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.phoneList = res.data.records
          this.pageTotal = res.data.total
        }
      }).catch(err => {
        this.$message.error(err.message || '获取数据失败')
      })
      //查询统计数据
      getPhoneCount(this.pageQuery).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.showCountData = res.data
        }
      }).catch(err => {
        this.$message.error(err.message || '获取统计数据失败')
      })
    },

    // 新增工作号
    handleAddPhone() {
      this.isEdit = false
      this.form = {
        phoneNumber: '',
        phoneOperator: '',
        planFee: 0.00,
        realName: '',
        remarkNote: ''
      }
      this.dialogVisible = true
    },

    // 修改工作号
    handleEditPhone(row) {
      this.isEdit = true
      this.form = {...row}
      this.dialogVisible = true
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            //修改
            editPhone(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success('修改成功')
                this.dialogVisible = false
                this.fetchPhoneList()
              }
            }).catch(err => {
              this.$message.error(err.message || '修改失败')
            })
          } else {
            //新增
            addPhone(this.form).then(res => {
              if (res.code === 200) {
                this.$message.success('新增成功')
                this.dialogVisible = false
                this.fetchPhoneList()
              }
            }).catch(err => {
              this.$message.error(err.message || '新增失败')
            })
          }
        }
      })
    },

    // 转交使用人
    handleTransfer(row) {
      this.rowPhoneId = row.id;
      console.log(row);
      this.form = {...row}
      this.dialogAssignVisible = true
    },

    // 查看操作记录
    handleViewHistory(row) {
      this.rowPhoneId = row.id;
      console.log(row);
      this.form = {...row}
      this.dialogCostVisible = true

      //临时参数
      let tempQuery = {
        phoneId: this.rowPhoneId
      };
      // 获取分配历史
      loadAssignRecord(tempQuery).then(res => {
        if (res.code === 200) {
          this.assignmentHistory = res.data.records
        }
      }).catch(err => {
        this.$message.error(err.message || '获取分配历史失败')
        this.assignmentHistory = [];
      })
    },
    //判断上传的文件
    exceedFile(files, fileList) {
      this.$message.warning(
          `只能选择 ${this.limitNum} 个文件，当前共选择了 ${
              files.length + fileList.length
          } 个`
      );
    },
    // 文件状态改变时的钩子
    fileChange(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.fileList = [];
        this.$message.warning("只能上传后缀是.xlsx的文件");
      }
      if (size > 30) {
        this.fileList = [];
        this.$message.warning("文件大小不得超过30M");
      }
      if (extension === "xlsx" && size < 30) {
        this.sendEmailError = [];
        this.fileList.push(file.raw);
      }
    },
    // 导入维护表
    handleImportMaintain() {
      this.importExcelDialog = true;
    },
    //确定处理 导入
    handleImportPhone() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件！");
        return;
      }
      this.hintMessage = "请稍等....";
      let form = new FormData();
      form.append("file", this.fileList[0]);
      importPhone(form).then((value) => {
        console.log(value);
        this.hintMessage = "开始导入";
        this.fileList = [];
        if (value.code === 200) {
          this.$message.success("导入成功");
        } else {
          this.$message.warning("导入失败,");
        }
      });
    },

    // 导出维护表
    handleExportMaintain() {
      exportExcel(this.pageQuery)
      this.$message.success("导出执行完成,请在右上角下载管理查看进度");
    }
  }
}
</script>

<style scoped>
.phone-list-container {
  padding: 20px;
}

.like {
  cursor: pointer;
  font-size: 25px;
  display: inline-block;
}
</style>
